import { SIZE_OPTIONS } from '@shared/config/build/size';
import { Application } from '@shared/typings/models/app/applicationList';
import { IBuildFormNode } from '@shared/typings/build/classes/node';

export const parseSize = (
	buildData: IBuildFormNode.Node[],
	consumeData: IBuildFormNode.Node[],
	imageSize?: Application.ImageSizes,
	defaultSize?: { defaultWidth?: string; defaultRatio?: number },
) => {
	const consumeSize = consumeData?.find(({ type }) => type === 'size') as IBuildFormNode.Size;
	const buildSize = buildData?.find(({ type }) => type === 'size') as IBuildFormNode.Size;
	const sizeItem = consumeSize ? consumeSize : buildSize;

	const { width, height } =
		(imageSize?.imageSize?.common?.find(
			(item) => item.sizeId === sizeItem?.sizeId,
		) as Application.Size) ?? {};

	let aspectRatio: number | undefined = width / height;
	if (!width || !height) {
		aspectRatio = SIZE_OPTIONS.find((item) => item.value === sizeItem?.sizeId)?.ratio;
	}

	return {
		width: width || defaultSize?.defaultWidth || 704,
		height: height ? height : 704,
		aspectRatio: aspectRatio || defaultSize?.defaultRatio || 1,
		sizeId: sizeItem?.sizeId || 1,
	};
};
